import initData from 'init-data';

export const getMessagingUrl = toLocalizedUrl =>
    initData.featureSwitches['messaging-in-touchweb']
        ? toLocalizedUrl(window.origin + '/messagingiframe')
        : location.hostname === 'beta-a.tradera.com'
        ? 'https://tradera-staging-messaging.firebaseapp.com'
        : initData.messagingIframeUrl;
